// extracted by mini-css-extract-plugin
export default {"bookingAlertContainer":"BookingAlert_bookingAlertContainer__Ts+Sw"};